import { render } from "./BaseLayout.vue?vue&type=template&id=1ac84d13"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"
script.render = render

export default script